import WalletValidatorWrapper from "./WalletValidatorWrapper";

export default function WalletConnectDialog() {
    return (
        <WalletValidatorWrapper dialog={{ description: "Sign in with your previously registered wallet" }}>
            <></>
        </WalletValidatorWrapper>
    );
}
